import { Component, OnInit, ChangeDetectorRef, inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { CommonModule, AsyncPipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../services/auth.service';


// STRIPE URL SUCCESS RETURN FORMAT
// 'success_url' => 'https://example.com/success?session_id={CHECKOUT_SESSION_ID}'
// ACTUAL RETURNED ULR
// https://rrbootcamp.com/success?session_id=cs_test_1234567890abcdefghijklmno

@Component({
    selector: 'app-success',
    templateUrl: './success.component.html',
    styleUrls: ['./success.component.css'],
    imports: [CommonModule, RouterLink, AsyncPipe]
})
export class SuccessComponent implements OnInit {

  isLoading = false;
  purchaseDetails: any;
  displayType: string = '';
  displayData: any = {};

  fileLocation = '/assets/downloads/';

  private destroyRef = inject(DestroyRef);

  constructor(private route: ActivatedRoute, private http: HttpClient, public auth: AuthService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {

    this.isLoading = true;

    this.route.queryParams.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(params => {
      let sessionId = params['session_id'];
      
      if (sessionId) {
        // Use the sessionId
        this.fetchOrderDetails(sessionId);
      }
      else{
         this.isLoading = false;
         this.cdr.markForCheck();
      }
    });
  }


  //http://localhost:4200/success?session_id=cs_test_b1WSPRvckIJrp10FTJMje3l1hPcgAquCMQn474OdSWlEnEwmcGfsqpLSCY

  fetchOrderDetails(sessionID: string){

      this.isLoading = true;
    
      this.http.post<any[]>('/api/products/getPurchaseDetailsFromSessionID.php', {'session_id': sessionID} ).subscribe({
          next: (data: any[]) => {
            // data is already parsed and is an array of objects
            //console.log(data);
          
            if (data && data.length > 0) {
              const purchaseDetails = data[0];

              // Determine the display type based on the item_CODE prefix
              const descPrefix = purchaseDetails.item_CODE.substring(0, 4);
  
              switch (descPrefix) {
                case 'RRZA':
                  this.displayType = 'RRZA';
                  this.displayData = {
                    name: purchaseDetails.name,
                    description: purchaseDetails.description,
                    time: purchaseDetails.time,
                    date: purchaseDetails.date,
                    url: purchaseDetails.url,
                    password: purchaseDetails.password,
                    classFiles: purchaseDetails.fileName,
                    classFilesURL: this.fileLocation + purchaseDetails.fileName
                  };
                  break;
                case 'RRZC':
                  this.displayType = 'RRZC';
                  this.displayData = {
                    name: purchaseDetails.name,
                    description: purchaseDetails.description,
                    time: purchaseDetails.time,
                    date: purchaseDetails.date,
                    url: purchaseDetails.url,
                    password: purchaseDetails.password,
                    classFiles: purchaseDetails.fileName,
                    classFilesURL: this.fileLocation + purchaseDetails.fileName
                  };
                  break;
                case 'RRBC':
                  this.displayType = 'RRBC';
                  this.displayData = {
                    name: purchaseDetails.name,
                    time: purchaseDetails.time,
                    date: purchaseDetails.date,
                    locationName: purchaseDetails.location_name,
                    street: purchaseDetails.street,
                    city: purchaseDetails.city,
                    state: purchaseDetails.state,
                    zip: purchaseDetails.zip,
                    classFiles: purchaseDetails.fileName,
                    classFilesURL: this.fileLocation + purchaseDetails.fileName
                  };
                  break;
                case 'RRVT':
                  this.displayType = 'RRVT';
                  this.displayData = {
                    name: purchaseDetails.name,
                    description: purchaseDetails.description,
                    classFiles: purchaseDetails.fileName,
                    classFilesURL: this.fileLocation + purchaseDetails.fileName                           
                  };
                  break;    
                default:
                  this.displayType = 'unknown';
                  this.displayData = {};
              }  
            }                   

            this.purchaseDetails = data[0];
            this.isLoading = false;
            this.cdr.markForCheck();
          },
          error: (error) => {
            this.isLoading = false;
            console.error('There was an error!', error);
            this.cdr.markForCheck();
          }
        });

    }

    isLoggedIn(): boolean {
      return this.auth.isLoggedIn();  
    }

  }


